export default __webpack_public_path__ + "static/media/1952.125e0ac2.png";